<template>
  <q-dialog ref="dialog" @hide="onDialogHide" persistent>
    <i-page class="q-dialog-plugin dialog-mini">
      <div v-if="title" class="panel-title" style="padding: 0 0 1em 0">{{title}}</div>
      <q-form ref="form" @reset="onFormReset()">
        <div v-for="item of pickItems" :key="item.name" style="background-color:inherit">
          <i-field ref="txtUsername" :value="getField(item.index).id"
            @input="onUsernameInput(item.index, $event)" field-type="dic" dic="user" :whiteList="whiteList" :label="item.text"
            :rules="[rules.required]" @keydown.enter.prevent="onFieldEnter($refs.txtUsername[item.index], $refs.txtPassword[item.index])"
            :readonly="item.readonly" />
          <i-field ref="txtPassword" :value="getField(item.index).password" @input="setField(item.index, {password: $event})" prepend-icon="vpn_key"
            type="password" :label="`${item.text}密码`" autocomplete="new-password" :rules="[rules.required]"
            @keydown.enter.prevent="onFieldEnter($refs.txtPassword[item.index], $refs.txtUsername[item.index+1] || onOKClick)" />
        </div>
      </q-form>
      <div class="dialog-mini-actions">
        <q-btn color="primary" label="取消" flat rounded @click="onCancelClick" icon="clear" />
        <q-btn color="primary" label="确定" rounded @click="onOKClick" icon="done" :loading="verifying" :disable="verifying" />
      </div>
    </i-page>
  </q-dialog>
</template>
<script>
import { StoreBisDicMixin, StoreBisAuthorizeMixin } from '@/lib/mixins'
import { PickUser } from '@/lib/enums'
import rules from '@/lib/rules.js'
import utilsBiz from '@/lib/utilsBiz'
import _ from 'lodash'

export default {
  mixins: [StoreBisDicMixin, StoreBisAuthorizeMixin],
  data: function () {
    return {
      rules,
      fields: [
        // {
        //   id: null,
        //   username: null,
        //   password: null
        // }
      ],
      pickedUsers: {
        // operator: {
        //   id: null,
        //   username: null,
        //   name: null
        // }
      },
      verifying: false,
      profilePickUsers: null
    }
  },
  props: {
    // 用法1: [PickUser.Operator, PickUser.Reviewer]
    // 用法2: [{ value: PickUser.Operator, presetUserId: 'admin', readonly: true, duplicate: false }]
    users: {
      type: Array,
      require: true,
      validator (val) {
        return !!val?.length
      }
    },
    title: String,
    profileKey: String,
    whiteList: Function
  },
  computed: {
    /*
    [{
      value: PickUser.Operator,
      text: '操作人',
      index: 0,
      fieldName: 'operator',
      readonly: false,
      duplicate: false,
      options: {
        value: P
      }
    }]
     */
    pickItems () {
      return this.users.map((user, index) => {
        const primitive = _.isNumber(user) || _.isString(user)
        const pickUser = PickUser.getItem(primitive ? user : user.value)
        const item = {
          ...pickUser,
          index: index,
          fieldName: _.camelCase(pickUser.name)
        }
        if (!primitive) {
          item.readonly = user.readonly
          item.duplicate = user.duplicate
          item.presetUserId = user.presetUserId
          item.options = user
        }
        if (this.profilePickUsers && !item.presetUserId) {
          item.presetUserId = this.profilePickUsers[item.fieldName]?.id
        }
        if (item.value === PickUser.Operator && !item.presetUserId) {
          item.presetUserId = this.$$user.id
        }
        return item
      })
    }
  },
  mounted () {
    this.reset() // async
  },
  watch: {
    pickItems: {
      handler (newVal) {
        const newFields = []
        for (let index = 0, length = newVal?.length ?? 0; index < length; index++) {
          const item = newVal[index]
          const userId = item.presetUserId
          if (!_.isNil(userId)) {
            const user = this.$$userById(userId)
            if (!user?.username) {
              console.warn(`根据id(${userId}:${typeof (userId)})未加载到用户信息`, user)
            }
            newFields[index] = { id: userId, username: user?.username }
          }
        }
        this.fields = newFields
      },
      immediate: true
    }
  },
  methods: {
    getField (index) {
      return this.fields.length > index ? this.fields[index] : {}
    },
    setField (index, value) {
      const computedValue = Object.assign({}, this.getField(index), value)
      this.$set(this.fields, index, computedValue)
    },
    onFormReset () {
      // nothing
    },
    async reset () {
      this.$refs.form && this.$refs.form.reset()
      if (this.profileKey) {
        this.profilePickUsers = await utilsBiz.getProfilePickUsers(this.profileKey)
      }
      setTimeout(() => {
        const length = this.$refs.txtUsername?.length
        if (length) {
          for (let index = 0; index < length; index++) {
            const field = this.fields[index]
            if (!field?.username && this.$refs.txtUsername[index]) {
              this.$refs.txtUsername[index].focus()
              break
            }
            if (!field?.password && this.$refs.txtPassword[index]) {
              this.$refs.txtPassword[index].focus()
              break
            }
          }
        }
      }, 200)
    },
    onFieldEnter (current, next) {
      setTimeout(async () => {
        const outcome = await current.validate()
        if (outcome) {
          if (typeof (next) === 'function') {
            next()
          } else {
            next.focus()
          }
        }
      }, 200)
    },
    onUsernameInput (itemIndex, input) {
      if (!input) return
      this.setField(itemIndex, { id: input, username: this.$$userById(input).username })
    },
    beforeVerify () {
      const usersArray = this.pickItems.map((item, index) => ({
        ...item,
        username: this.getField(index).username
      }))
      const params = {
        usersArray,
        users: _.fromPairs(usersArray.map(item => [item.fieldName, item])),
        invalidMessage: null
      };
      // 排除重复user
      (function () {
        const usersLength = usersArray.length
        for (let index0 = 0, end0 = usersLength - 1; index0 < end0; index0++) {
          for (let index1 = index0 + 1, end1 = usersLength; index1 < end1; index1++) {
            const item0 = usersArray[index0]
            const item1 = usersArray[index1]
            if (!item0.duplicate && !item1.duplicate && item0.username === item1.username) {
              params.invalidMessage = `${item0.text} 与 ${item1.text} 不能是同一人`
            }
          }
        }
      })()

      if (!params.invalidMessage) {
        this.$emit('before-verify', params)
      }
      if (params.invalidMessage) {
        this.$q.notify({ type: 'negative', message: params.invalidMessage })
        return false
      } else {
        return true
      }
    },
    async submit () {
      const valid = await this.$refs.form.validate()
      if (!valid) {
        return false
      }
      if (!this.beforeVerify()) {
        return false
      }
      this.verifying = true
      const result = await this.$$api.bis.post('/sys/user/verify', {
        users: this.fields
      })
      this.verifying = false
      result.notifyIfFail()
      if (!result.success) {
        return false
      }
      let errorCount = 0
      const pickedUsers = { }
      for (let i = 0, length = result.data.results.length; i < length; i++) {
        const itemResult = result.data.results[i]
        const fieldItem = this.pickItems[i]
        if (itemResult.success) {
          pickedUsers[fieldItem.fieldName] = itemResult.data
        } else {
          errorCount++
          this.$q.notify({
            type: 'negative',
            message: itemResult.message
          })
          const txtPassword = this.$refs.txtPassword[i]
          if (errorCount === 1) {
            this.setField(fieldItem.index, { password: '' })
            this.$nextTick(() => {
              txtPassword.focus()
            })
          }
        }
      }
      if (errorCount === 0) {
        this.pickedUsers = pickedUsers
        await utilsBiz.setProfilePickUsers(this.profileKey, pickedUsers)
        return true
      } else {
        return false
      }
    },

    // following method is REQUIRED
    // (don't change its name --> "show")
    show () {
      this.$refs.dialog.show()
    },

    // following method is REQUIRED
    // (don't change its name --> "hide")
    hide () {
      this.$refs.dialog.hide()
    },

    onDialogHide () {
      // required to be emitted
      // when QDialog emits "hide" event
      this.$emit('hide')
    },

    async onOKClick () {
      const success = await this.submit()
      if (!success) {
        return
      }
      // on OK, it is REQUIRED to
      // emit "ok" event (with optional payload)
      // before hiding the QDialog
      this.$emit('ok', {
        success: true,
        pickedUsers: this.pickedUsers
      })
      this.hide()
    },

    onCancelClick () {
      // we just need to hide dialog
      this.hide()
    }
  }
}
</script>
<style lang="scss" scoped>
.bg-login {
  width: 400px;
  border-radius: 0.5em;
  box-shadow: 0 0 10px 2px rgba(0, 0, 0, 0.2);
  padding: 1.5em;
  &__actions {
    display: flex;
    justify-content: flex-end;
    padding: 40px 0 0 0;
    > * {
      margin-left: 20px;
    }
  }
}
</style>
